import type {Category,Story} from '../stories.ts';
import legacy from './legacy-map.json' with {type:'json'};
export const stories:Story[]=[];
export const categories:Category[]=[];
export const legacySlideMap:Record<string,number[]>={...legacy};
export function registerEditorial(items:Story[],groups:readonly Category[],legacy:Record<string,number[]>){
 stories.splice(0,stories.length,...items);categories.splice(0,categories.length,...groups);Object.assign(legacySlideMap,legacy);
}
export const labels:Record<string,Record<string,string>>={};
let revision=0;
const listeners=new Set<()=>void>();
export function notifyCatalogue(){revision++;for(const callback of listeners)callback();}
export const subscribeCatalogue=(callback:()=>void)=>{listeners.add(callback);return()=>{listeners.delete(callback);};};
export const catalogueRevision=()=>revision;
export const hasStory=(id:string)=>stories.some(s=>s.id===id);
export function registerStories(items:Story[]){for(const item of items){const index=stories.findIndex(s=>s.id===item.id);if(index<0)stories.push(item);else stories[index]=item;}notifyCatalogue();}
